import { format, parseISO } from 'date-fns';
import locale from 'date-fns/locale/pl';

export const NUMBER_DATE_TIME_PATTERN = 'yyyy-MM-dd HH:mm:ss';

export default (date, pattern) => format(parseISO(date), pattern, { locale });
